<template>
    <div class="erpsku-multiple-input">
        <div class="erpsku-multiple-input-container">
            <Input class="erpsku-multiple-input-input" type="textarea" v-model="erpSku" :rows="1" :autosize="true" v-bind="inputProps" @on-blur="handlesearch" />
            <Icon class="erpsku-multiple-input-search-icon" type="ios-search" style="font-size: 20px; margin-right: 10px; cursor: pointer;" slot="suffix" @click="handleShowERPSKU" />
        </div>
        <compModal v-model="modalProps.show" v-bind="modalProps">
            <compErpSku :isManage="erpskutype == 'manage'" :multiple="true" @on-data="handleSelectERPSKU" @on-close="modalProps.show = false"></compErpSku>
        </compModal>
    </div>
</template>
<script>
import compErpSku from '@components/templates/erpsku.vue';
export default {
    props: {
        value: {
            type: String
        },
        inputProps: {
            type: Object
        },
        showread:String,
        erpskutype:String,
    },
    components: {
        compErpSku,
    },
    watch: {
        value: {
            immediate: true,
            handler (val) {
                console.log('改变erpsku', val)
                if (!val) return this.erpSku = "";
                this.erpSku = val.join("\n");
            },
        }
    },
    data () {
        return {
            row: {},
            erpSku: '',
            modalProps: {
                show: false,
                showFooter: false,
                title: this.$t('erp.product.product_query', { defaultValue: '产品查询' }),
                width: 1000
            }
        }
    },
    mounted() {
        // this.bus.$on("changereset", value => {
        //     if(value === 'reset'){
        //         this.erpSku = ''
        //     }

        // });
	},
    methods: {
        handleShowERPSKU () {
            this.modalProps.show = true;
        },
        handlesearch(){
            if (Array.isArray(this.erpSku)) {
                this.$emit("on-data", this.erpSku);
            }
            else {
                this.$emit("on-data", this.erpSku.split("\n"));
            }
        },
        handleSelectERPSKU (row) {
            console.log("handleSelectERPSKU", row)
            // 多选模式下返回数组
            this.modalProps.show = false;
            // this.row = row;
            this.erpSku = row.join("\n");
            // this.value = this.erpSku;
            this.$emit('on-data', row);
            this.$emit('on-change', row);
        }
    }
}
</script>
<style lang="scss" scoped>
.erpsku-multiple-input {
    display: inline-block;
    width: 100%;

    &-container {
        // width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    &-search-icon {
        margin-left: 5px;
    }
}
</style>